import { ConfigState } from 'src/store/reducers/config.reducer';

export class SesammStorage {
    // Session storage keys
    private static configStorageKey = '__config_storage_';

    // Clear
    public static clearSessionStorage(): void {
        this.removeConfigStorage();
    }

    // Get
    public static getConfigStorage(): ConfigState {
        return JSON.parse(localStorage.getItem(this.configStorageKey) ?? '{}');
    }

    // Remove
    public static removeConfigStorage(): void {
        localStorage.removeItem(this.configStorageKey);
    }

    // Set
    public static setConfigStorage(state: ConfigState): void {
        localStorage.setItem(this.configStorageKey, JSON.stringify(state));
    }
}
